import { GeneralExperiencePageModule } from './../pages/general-experience/general-experience.module';
import { XsellUpsellPageModule } from './../pages/xsell-upsell/xsell-upsell.module';
import { ClosingSalePageModule } from './../pages/closing-sale/closing-sale.module';
import { PresentationProductPageModule } from './../pages/presentation-product/presentation-product.module';
import { NeedsDiagnosisPageModule } from './../pages/needs-diagnosis/needs-diagnosis.module';
import { ContactSocketPageModule } from './../pages/contact-socket/contact-socket.module';
import { WelcomePageModule } from './../pages/welcome/welcome.module';
import { LandingPageModule } from './../pages/landing/landing.module';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { HttpClientModule } from '@angular/common/http';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { WelcomePage } from './../pages/welcome/welcome';
import { ContactSocketPage } from './../pages/contact-socket/contact-socket';
import { NeedsDiagnosisPage } from './../pages/needs-diagnosis/needs-diagnosis';
import { PresentationProductPage } from './../pages/presentation-product/presentation-product';
import { ClosingSalePage } from './../pages/closing-sale/closing-sale';
import { XsellUpsellPage } from './../pages/xsell-upsell/xsell-upsell';
import { GeneralExperiencePage } from './../pages/general-experience/general-experience';
import { ComponentsModule } from '../components/components.module';
import { LandingPage } from '../pages/landing/landing';



import {
  TranslateModule,
  TranslateLoader,
  TranslatePipe
} from '@ngx-translate/core';
import { TranslatePoHttpLoader } from '@biesbjerg/ngx-translate-po-http-loader';
import { HttpClient } from '@angular/common/http';
import { BqApiProvider } from '../providers/bq-api/bq-api';

export function createTranslateLoader(http: HttpClient) {
  return new TranslatePoHttpLoader(http, 'assets/i18n', '.po');
}

@NgModule({
  declarations: [MyApp, HomePage ],
  imports: [
    BrowserModule,
    ComponentsModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp),
    LandingPageModule,
    WelcomePageModule,
    ContactSocketPageModule,
    NeedsDiagnosisPageModule,
    PresentationProductPageModule,
    ClosingSalePageModule,
    XsellUpsellPageModule,
    GeneralExperiencePageModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LandingPage,
    HomePage,
    WelcomePage,
    ContactSocketPage,
    NeedsDiagnosisPage,
    PresentationProductPage,
    ClosingSalePage,
    XsellUpsellPage,
    GeneralExperiencePage,

  ],
  providers: [
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    BqApiProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts